import { FilterOption } from '../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  { key: 'origin', label: 'Origen', type: 'text', order: 1 },
  { key: 'name', label: 'Marca', type: 'text', order: 2 },
  {
    key: 'orderOriginId',
    label: 'Canal de Venta',
    type: 'precreated',
    order: 3
  },
  {
    key: 'typeStorageId',
    label: 'Tipo de Almacenamiento',
    type: 'precreated',
    order: 4
  },
  { key: 'isActive', label: 'Activo', type: 'yesornotoption', order: 5 }
]
